import { Routes } from '@angular/router';
import { IdeaDetailComponent } from './idea-detail/idea-detail.component';
import { IdeaSubmitComponent } from './idea-submit/idea-submit.component';
import { IdeasListComponent } from './ideas-list/ideas-list.component';

/**
 * Ideas. Mounted twice: at `/ideas` in the interculturalist application, and
 * at `/hubs/:hub/ideas` as a hub's own view, where the screens read the hub
 * from the route — see `ideasHubSlug()`. Signed-in readers only: there is no
 * public, unauthenticated list.
 */
export const ideasRoutes: Routes = [
  {
    path: '',
    component: IdeasListComponent,
  },
  {
    path: 'new',
    component: IdeaSubmitComponent,
    data: { label: 'Submit an idea', translationKey: 'ideas.submit_an_idea', translationScope: 'ideas', labelSource: null },
  },
  {
    path: ':slug',
    component: IdeaDetailComponent,
    data: { label: 'Idea', translationKey: null, labelSource: 'titleService' },
  },
];
